<template>
    <div class="container">
      <QueryFrame
        @handlePage='handlePage'
        @handlePageSize='handlePageSize'
        :disablePage='disablePage'
        :current='page'
        :count='count'
      >
        <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>创建时间:</label>
              <DtpDatePicker class="item" placeholder=" 请选择" clearable v-model.trim='query.duration' />
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select class="item" clearable v-model.trim='query.source'>
              <lk-option v-for="(item,index) in sourceList" :key="index" :value='item'>
                {{item}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>患者姓名:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.patientName'></lk-input>
          </div>
          <div class="queryItem">
            <label>联系方式:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.consigneePhone' />
          </div>
          <div class="queryItem">
            <label>处方医生:</label>
            <lk-input :maxlength='100' class="item" placeholder='请输入' clearable v-model.trim='query.doctor' />
          </div>
          <div class="queryItem">
            <label>订单状态:</label>
            <lk-select class="item" clearable v-model.trim='query.status'>
              <lk-option v-for="(item,index) in statusList" :key="index" :value='item.id'>
                {{item.name}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>联系人:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.contact'/>
          </div>
          <div class="queryItem"  v-if="roleType!==2">
            <label>门店名称:</label>
            <StoreListSelect class="item" clearable v-model.trim='query.storeIdList'></StoreListSelect>
          </div>
          <div class="queryItem">
              <label>小程序订单号:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.appletOrderCode'/>
            </div>
            <div class="queryItem">
              <label>三方订单号:</label>
              <lk-input :maxlength='50' placeholder='请输入' class="item" clearable v-model.trim='query.onlineOrderCode'/>
            </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
        </div>
        <div slot="table">
          <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('OTCDownload')"></DownloadButton>
            <lk-table border :columns='columns' :data='tableData'></lk-table>
        </div>
      </QueryFrame>
      <!-- 小程序预约单取消预约弹窗 -->
      <CancelOrderModal
        v-model="cancelModal"
        @getData='getData'
        :cancelOrderParams="cancelOrderParams"
      ></CancelOrderModal>
      <lk-modal
        v-model="checkOrderModal.isShow"
        title="审核订单"
        @on-ok="toCheck"
      >
        <div style="display:flex;align-items:center;justify-content:center;">
          <div>审核结果：</div>
          <div>
            <lk-select v-model="checkOrderModal.checkResult" style="width:200px;">
              <lk-option v-for="item in checkOrderModal.checkList" :key="item.id" :value='item.id'>
                {{item.name}}
              </lk-option>
            </lk-select>
          </div>
        </div>
      </lk-modal>
    </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
// import supplier from '../../services/supplier';
import cnPrint from '@/libs/cainiaoPrint';
import sale from '../../services/sale';
import DtpDatePicker from '../../components/DtpDatePicker.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';
import CancelOrderModal from '../../components/prescription/CancelOrderModal.vue';

export default {
  name: 'OTCOrderList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DtpDatePicker,
    DownloadButton,
    CancelOrderModal,
  },
  data() {
    return {
      checkOrderModal: {
        isShow: false,
        checkResult: '01', // 审核结果
        orderId: '', // 镁信订单号
        checkList: [
          {
            id: '01',
            name: '审核通过'
          },
          {
            id: '02',
            name: '审核不通过'
          },
        ] 
      },
      printData: '', // 打印信息
      sourceList: [],
      cancelModal: false, // 预约弹窗
      cancelOrderParams: { // 取消预约入参
        epId: null,
        appId: null,
      },
      statusList: [
        {
          id: 1,
          name: '待出库',
        },
        {
          id: 3,
          name: '已出库',
        },
        {
          id: 11,
          name: '退款审核中',
        },
        {
          id: 6,
          name: '已取消',
        },
        {
          id: 2,
          name: '已失效',
        },
      ],
      query: {
        duration: [],
        source: null,
        contact: '',
        patientName: null,
        consigneePhone: null,
        doctor: null,
        status: null,
      },
      columns: [
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '来源', key: 'source', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '是否商保支付', key: 'paymentStatusName', minWidth: 116 },
        { title: '商保支付金额', key: 'proceedsAmount', minWidth: 116 },
        { title: '收货人姓名', key: 'consigneeName', minWidth: 116 },
        { title: '联系方式', key: 'consigneePhone', minWidth: 116 },
        { title: '收货地址', key: 'consigneeAddress', minWidth: 116 },
        { title: '备注', key: 'remark', minWidth: 116 },
        { title: '订单状态', key: 'statusName', minWidth: 116 },
        { title: '销售订单号', key: 'orderCode', minWidth: 116 },
        { title: 'ID类型', key: 'creatorTypeName', minWidth: 116 },
        { title: 'ID', key: 'creatorId', minWidth: 116 },
        { title: '来源姓名', key: 'creator', minWidth: 116 },
        { title: '三方订单号', key: 'onlineOrderCode', minWidth: 116 },
        { title: '小程序订单号', key: 'appletOrderCode', minWidth: 116 },
        { title: '取消原因', key: 'cancelReasonName', minWidth: 116 },
        { title: '联系人', key: 'contact', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            const edit = this.handlePermission('OTCOrderEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'OTCOrderEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null;
            const check = this.handlePermission('OTCOrderCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'OTCOrderCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null;
            const create = this.handlePermission('OTCOrderSale') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'OTCOrderSale', params: { id: params.row.id } });
                },
              },
            }, '创建销售订单') : null;
            const orderCheck = this.handlePermission('salesOrderCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'salesOrderCheck', params: { id: params.row.orderId } });
                },
              },
            }, '查看销售订单') : null;
            // 小程序预约取消预约按钮
            const cancel = this.handlePermission('OTCOrderCancel') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.cancelModal = true;
                  const { id, appId, createTime } = params.row;
                  const time = new Date(createTime).getTime();
                  if (new Date().getTime() - time > 1000 * 60 * 60 * 24 * 365) {
                    this.$Message.warning('交易时间超过一年的订单无法微信原路退款，请联系患者进行线下退款。');
                  }
                  this.cancelOrderParams = {
                    epId: id,
                    appId,
                  };
                },
              },
            }, '取消预约') : '';
            // 菜鸟打印
            const cainiaoPrint = this.handlePermission('cainiaoPrint') && params.row.sourceType != 13 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  // 打印
                  this.handlerPrint(params.row.id);
                },
              },
            }, '打印面单') : '';
            const auditOrder = this.handlePermission('orderAudit') ? h('lk-button', { // 镁信来源增加审核订单按钮
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.checkOrderModal.isShow = true;
                  this.checkOrderModal.orderId = params.row.onlineOrderCode;
                  this.checkOrderModal.checkResult = '01';
                },
              },
            }, '审核订单') : '';
            if (params.row.status === 1) {
              if ([10, 13].indexOf(params.row.sourceType) >= 0) {
                return [edit, create];
              }
              return h('div', [edit, create, cancel]);
            }
            if (params.row.status === 6 || params.row.status === 2 || params.row.status === 11) {
              return check;
            }
            if (params.row.status === 3 && [10, 13].indexOf(params.row.sourceType) >= 0) {
              return h('div', [check, orderCheck, cainiaoPrint]);
            }
            if (params.row.status === 7) {
              return h('div', [edit, auditOrder]);
            }
            return h('div', [
              check, orderCheck,
            ]);
          },
        },
      ],
      tableData: [],
      page: 1,
      // size: 10,
      count: 0,
      localtion: [],
      kmCode: '',
    };
  },
  methods: {
    toCheck() {
      const { checkResult, orderId } = this.checkOrderModal;
      const params = {
        orderStatus: checkResult,
        mxOrderNo: orderId,
      }
      sale.checkOrder(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('操作成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handlerPrint(epId) {
      cnPrint.getPrintData(epId, (res) => {
        this.loading = false;
        if (res.status == 'failed') {
          this.$Message.error(res.msg);
          return;
        }
        if (res.status === 'success' && res.cmd === 'print') {
          this.$Message.success('已加入打印队列，请等待');
        }
      },
      (err) => {
        this.$Modal.error({
          title: '温馨提示',
          content: `<p>${err}</p>`
        })
      });
    },
    download() {
      const params = utils.deepClone(this.params);
      params.page = 0;
      params.size = 0;
      params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      delete params.duration;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      params.typeList = [2, 6];
      sale.getPrescriptionListDownload(params).then((res) => {
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    testKmCode() {

    },
    clear() {
      this.query = {
        duration: [],
        contact: '',
        source: null,
        patientName: null,
        consigneePhone: null,
        doctor: null,
        status: null,
      };
    },
    getlocaltions() {

    },
    loadLocaltion() {

    },
    getSourceList() {
      sale.getSourceList({ typeList: [2, 6] }).then((res) => {
        if (res.data.status === 200) {
          this.sourceList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      this.params.duration && ([this.params.createTimeStart, this.params.createTimeEnd] = this.params.duration);
      delete this.params.duration;
      this.params.typeList = [2, 6];
      sale.getPrescriptionList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = utils.deepClone(item.ep);
            result.proceedsAmount = item.proceedsAmount;
            // result.isGoodsBaseOnly = item.isGoodsBaseOnly;
            result.orderStatusName = item.orderStatusName;
            result.createTime = utils.formatTime(result.createTime);
            result.patientGenderString = this.publicParams.genderList[result.patientGender];
            // result.paymentStatusString = this.publicParams.judgeList[result.paymentStatus];
            result.id = result.id || null;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    addNew() {
      this.$router.push({ name: 'supplierGeneralAdd' });
    },

  },
  mounted() {
    this.getSourceList();
    this.handleSearch(true);
  },
};
</script>

<style lang="less" scoped>
</style>
